import { useParams, useNavigate } from 'react-router-dom'
import { useCallback } from 'react'
import { useTenant } from '@/contexts/TenantContext'
import { getSportLabel } from '@/lib/tenant'

export type Sport = 'men' | 'women'

export function useSport() {
  const { sport } = useParams<{ sport: string }>()
  const navigate = useNavigate()
  const tenant = useTenant()

  const currentSport: Sport = sport === 'women' ? 'women' : 'men'
  const sportLabel = getSportLabel(tenant.sportCategory, currentSport)

  const toggleSport = useCallback(() => {
    const newSport = currentSport === 'men' ? 'women' : 'men'
    navigate(window.location.pathname.replace(`/${currentSport}`, `/${newSport}`))
  }, [currentSport, navigate])

  return { sport: currentSport, sportLabel, toggleSport }
}
